module.exports = __webpack_public_path__ + "static/media/EffectiveCounselingSecrets.831ea486.jpg";